import {
    CommonAdobeAnalyticsUtil, SphAdobeAnalyticsUtil
} from 'saga-modules';

// eslint-disable-next-line valid-jsdoc
/**
 * Gets contentReplacementCost value
 * @returns numeric value
 */
function getContentReplacementCost(source) {
    let value;

    if (source === 'more_than_one_hundred_thousand') {
        value = 100001;
    }
    if (source === 'up_to_one_hundred_thousand') {
        value = 100000;
    } else if (source === 'up_to_seventy_five_thousand') {
        value = 75000;
    } else if (source === 'up_to_forty_thousand') {
        value = 40000;
    }
    return value;
}

const SPH_TAGGING_PROPERTIES = {
    coverType: {
        id: 'coverType'
    },
    propertyDetails: {
        id: 'propertyDetails'
    },
    propertyCategory: {
        id: 'property',
        transform: (value) => {
            const val = value.code ? CommonAdobeAnalyticsUtil.getTypelistValue('SPHPropertyCategory_Ext', value.code) : value;
            return val === 'Flat / Maisonette' ? 'Flat' : val;
        }
    },
    propertyType: {
        id: 'propertyType',
        transform: (value) => {
            return value.code ? CommonAdobeAnalyticsUtil.getTypelistValue('SPHPropertyType_Ext', value.code) : value;
        }
    },
    approxYearBuild: {
        id: 'propertyBuilt',
        transform: (value) => {
            return value.code ? CommonAdobeAnalyticsUtil.getTypelistValue('SPHYearBuildingBuilt_Ext', value.code) : value;
        },
    },
    isMainResidence: {
        id: 'mainResidenceProperty',
        dependent: ['propertyUse']
    },
    propertyUse: {
        id: 'mainPropertyUse',
        transform: (value) => {
            return value.code ? CommonAdobeAnalyticsUtil.getTypelistValue('SPHPropertyUse_Ext', value.code) : value;
        },
        getValue: (value) => {
            if (value === true) {
                return 'Main residence';
            }
            return '';
        }
    },
    numberOfBedrooms: {
        id: 'numberOfBedrooms',
        transform: (value) => {
            return value.code || value;
        }
    },
    moreThanQuarterRoofFlat: {
        id: 'flatRoof',
        transform: (value) => ((value === false) ? '0-25%' : value)
    },
    moreThanHalfRoofFlat: {
        id: 'flatRoof',
        transform: (value) => ((value === true) ? 'Over 50%' : '25-50%')
    },
    propertyRented: { id: 'mainPropertyRent' },
    productName: {
        id: 'productName'
    },
    product: {
        id: 'product'
    },
    coverLevelType: {
        id: 'coverType',
        transform: (value) => {
            return value.code || undefined;
        }
    },
    contentsSumInsured: {
        id: 'contentsSumInsuredOver75k',
        getValue: (value) => {
            if (value.code !== undefined) {
                return getContentReplacementCost(value.code) > 75000;
            }
            return value > 75000;
        },
        dependent: ['contentsCoverValue']
    },
    contentsCoverValue: {
        id: 'contentReplacementCost',
        transform: (value) => getContentReplacementCost(value.code),
        dependent: ['contentsSumInsured'],
        getValue: (value) => {
            if (value === false) {
                return 75000;
            }
            return '';
        }
    },
    contentsValue: {
        id: 'contentReplacementCost',
        transform: (value) => (value.name),
        dependent: ['contentsSumInsured'],
        getValue: (value) => {
            if (value === false) {
                return 75000;
            }
            return '';
        }
    },
    contentsValueTotal: {
        id: 'contentReplacementCost',
        transform: (value) => {
            return value || undefined;
        },
        dependent: ['contentsSumInsured']
    },
    landlordContentsTotal: {
        id: 'contentReplacementCost',
        transform: (value) => {
            return value.code || undefined;
        },
        dependent: ['contentsSumInsured']
    },

    employmentStatusSelectPolicyHolder: {
        id: 'employmentStatus',
        transform: (value) => {
            return CommonAdobeAnalyticsUtil.getTypelistValue('EmploymentStatus_Ext', value);
        }
    },
    occupationTypeSelectPolicyHolder: {
        id: 'occupation',
        transform: (value) => {
            return value.code ? CommonAdobeAnalyticsUtil.getTypelistValue('OccupationType_Ext', value.code) : undefined;
        }
    },
    hasJointPolicyHolder: { id: 'addJointPolicyHolder' },
    hasHomeClaims: {
        id: 'anyHomeInsuranceClaims'

    },
    claimsArray: {
        id: 'claimsArray',
        transform: (claimItems) => {
            const claimsObjects = claimItems && claimItems.map(SphAdobeAnalyticsUtil.createClaimsTrackingObject);
            return SphAdobeAnalyticsUtil.setArray(claimsObjects);
        }
    },
    hasBusinessUse: { id: 'businessUse' },
    hasSubsidenceHeaveLandslip: { id: 'propertySubsidence' },
    hasFloodingAtProperty: { id: 'propertyFlooded' },
    promoCode: { id: 'promoCode' },
    sourceOfBusiness: {
        id: 'whatBroughtYouToSaga',
        transform: (value) => {
            return value.code ? CommonAdobeAnalyticsUtil.getTypelistValue('SourceOfBusiness_Ext', value.code) : undefined;
        }
    },
    coverLevel: { id: 'coverType' },
    currentPaymentType: {
        id: 'paymentByInstalments',
        transform: (value) => {
            return value.code || undefined;
        }
    },
    hasFixedPrice: { id: 'fixedPrice' },
    hasContentsAccidentCover: { id: 'contentsAccidentalDamage' },
    hasBuildingsAccidentCover: { id: 'buildingsAccidentalDamage' },
    unspecifiedItemsCover: {
        id: 'personalBelongings',
        transform: (value) => {
            if (value.code === 'zero') {
                return 0;
            } if (value.code === 'two_thousand_five_hundred') {
                return 2500;
            } if (value.code === 'five_thousand') {
                return 5000;
            } if (value.code === 'ten_thousand') {
                return 10000;
            }
            return '';
        }
    },
    hasLegalCover: { id: 'legalExpenses' },
    hasSheCover: { id: 'homeEmergency' },
    hasHeatingCover: { id: 'heatingCover' },
    hasBoilerCover: { id: 'boilerCover' },
    contentsCoverLevel: {
        id: 'contentsCoverLevel',
        transform: (value) => {
            return SphAdobeAnalyticsUtil.getHomeCoverLevel(value);
        }
    },
    buildingsCoverLevel: {
        id: 'buildingsCoverLevel',
        transform: (value) => {
            return SphAdobeAnalyticsUtil.getHomeCoverLevel(value);
        }
    },
    specItemsArray: {
        id: 'specItemsArray',
        transform: (specifiedItems) => {
            const specifiedItemsObjects = specifiedItems && specifiedItems.map(SphAdobeAnalyticsUtil.createSpecifiedItemsTrackingObject);
            return SphAdobeAnalyticsUtil.setArray(specifiedItemsObjects);
        }
    },
    hasAbilityToPay: { id: 'hasAbilityToPay' },
    hasDocuSign: { id: 'hasDocuSign' }
};

export default SPH_TAGGING_PROPERTIES;
